import api from './index';
//
let exports = {};

// 获取-值班任务
exports.getRetailerDutyTaskInfo = function (data, callback) {
    api.post('/perform/retailer/duty/task/get')
    .data(data)
    .done(callback)
    .go();
};

// 获取-值班任务列表（针对-某人某月）
exports.getRetailerDutyTaskList = function (postData, callback) {
    api.post('/perform/retailer/duty/task/list/get')
    .data(postData)
    .done(callback)
    .go();
};

// 新增-值班任务（针对-某人某月）
exports.saveRetailerDutyTask = function (postData, callback) {
    api.post('/perform/retailer/duty/task/save/do')
    .data(postData)
    .done(callback)
    .go();
};

// 更新-值班任务
exports.updateRetailerDutyTask = function (postData, callback) {
    api.post('/perform/retailer/duty/task/update/do')
    .data(postData)
    .done(callback)
    .go();
};

// 执行-值班任务
exports.updateRetailerDutyTaskDoneFlag = function (postData, callback) {
    api.post('/perform/retailer/duty/task/doneFlag/update/do')
    .data(postData)
    .done(callback)
    .go();
};

//删除-值班任务
exports.deleteRetailerDutyTask = function (postData, callback) {
    api.post('/perform/retailer/duty/task/delete/do')
    .data(postData)
    .done(callback)
    .go();
};

// 获取值班任务附件列表
exports.getRetailerDutyTaskFileList = function (postData, callback) {
    api.post('/perform/retailer/duty/task/file/list/get')
    .data(postData)
    .done(callback)
    .go();
};

// ============================= 多人多天 =============================
// 获取-值班任务列表（针对-某人某月）
exports.getRetailerDutyTaskListByFilter = function (postData, callback) {
    api.post('/perform/retailer/duty/task/list/get/by/filter')
    .data(postData)
    .done(callback)
    .go();
};

// =============================== 零售商周期任务 =======================
// 获取零售商周期任务列表
exports.getRetailerPeriodicTaskList = function (data, callback) {
    api.post('/perform/retailer/periodic/task/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 获取零售商周期任务详情
exports.getRetailerPeriodicTaskInfo = function (params, callback) {
    api.get('/perform/retailer/periodic/task/get')
    .params(params)
    .done(callback)
    .go();
};

// 保存零售商周期任务
exports.saveRetailerPeriodicTask = function (data, callback) {
    api.post('/perform/retailer/periodic/task/save/do')
    .data(data)
    .done(callback)
    .go();
};

// 结束周期任务
exports.udpateRetailerPeriodicTaskTerminated = function (data, callback) {
    api.post('/perform/retailer/periodic/task/terminated/do')
    .data(data)
    .done(callback)
    .go();
};

// 删除零售商周期任务
exports.deleteRetailerPeriodicTask = function (data, callback) {
    api.post('/perform/retailer/periodic/task/delete/do')
    .data(data)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/dutyTask.js
// module id = 112
// module chunks = 0